var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco713Template = function SvgFefco713Template(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "634.0mm",
    height: "408.0mm",
    viewBox: "0.0 0.0 634.0 408.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 100,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 0,
    y1: 319.5,
    y2: 319.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 101.5,
    y1: 112,
    y2: 319.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 303,
    x2: 103,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 304.5,
    x2: 304.5,
    y1: 319.5,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 104.5,
    x2: 303,
    y1: 321,
    y2: 321,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    x2: 151.5,
    y1: 327,
    y2: 371,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 413.5,
    x2: 457.5,
    y1: 327,
    y2: 371,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 304.5,
    x2: 406,
    y1: 319.5,
    y2: 319.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 407.5,
    x2: 407.5,
    y1: 112,
    y2: 319.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 306,
    x2: 406,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 407.5,
    x2: 609,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 609,
    x2: 609,
    y1: 319.5,
    y2: 112,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 410.5,
    x2: 607.5,
    y1: 321,
    y2: 321,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 100,
    y1: 60.5,
    y2: 60.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 100,
    y1: 112,
    y2: 60.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 103,
    y1: 15,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 293.5,
    x2: 112.5,
    y1: 15,
    y2: 15,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 303,
    x2: 303,
    y1: 112,
    y2: 15,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 306,
    x2: 406,
    y1: 60.5,
    y2: 60.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 306,
    x2: 306,
    y1: 112,
    y2: 60.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 406,
    x2: 406,
    y1: 112,
    y2: 60.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 634,
    x2: 609,
    y1: 118.25,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 634,
    x2: 634,
    y1: 294.5,
    y2: 118.25,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 607.5,
    x2: 609,
    y1: 321,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 634,
    x2: 609,
    y1: 294.5,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 602.5,
    x2: 607.5,
    y1: 408,
    y2: 321,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 539.25,
    x2: 602.5,
    y1: 408,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 508.25,
    x2: 539.25,
    y1: 377,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 508.25,
    x2: 508.25,
    y1: 371,
    y2: 377,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 457.5,
    x2: 508.25,
    y1: 371,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 420.5,
    x2: 457.5,
    y1: 408,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 415.5,
    x2: 420.5,
    y1: 408,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 409,
    x2: 415.5,
    y1: 331.5,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 415,
    x2: 409,
    y1: 325.5,
    y2: 331.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 410.5,
    x2: 415,
    y1: 321,
    y2: 325.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 409,
    x2: 410.5,
    y1: 319.5,
    y2: 321,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 406,
    x2: 409,
    y1: 319.5,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 401,
    x2: 406,
    y1: 371,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 356,
    x2: 401,
    y1: 371,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 304.5,
    x2: 356,
    y1: 319.5,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 303,
    x2: 304.5,
    y1: 321,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    x2: 303,
    y1: 408,
    y2: 321,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 234,
    x2: 298,
    y1: 408,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 203,
    x2: 234,
    y1: 377,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 203,
    x2: 203,
    y1: 371,
    y2: 377,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    x2: 203,
    y1: 371,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    x2: 114.5,
    y1: 408,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    x2: 114.5,
    y1: 371,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 109.5,
    y1: 331.5,
    y2: 408,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 109,
    x2: 103,
    y1: 325.5,
    y2: 331.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 104.5,
    x2: 109,
    y1: 321,
    y2: 325.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 104.5,
    y1: 319.5,
    y2: 321,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 103,
    y1: 319.5,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 101.5,
    y1: 319.5,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    x2: 100,
    y1: 371,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 51.5,
    x2: 95,
    y1: 371,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 51.5,
    y1: 319.5,
    y2: 371,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 112,
    y2: 319.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 60.5,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 101.5,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 101.5,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 303,
    x2: 304.5,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 306,
    x2: 304.5,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 406,
    x2: 407.5,
    y1: 112,
    y2: 112,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 303,
    x2: 293.5,
    y1: 15,
    y2: 15,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 286.5,
    x2: 119.5,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    x2: 112.5,
    y1: 15,
    y2: 15,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 104.5 15 Q 104.5 0 119.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 301.5 15 Q 301.5 0 286.5 0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco713Template, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-713-template.7b6c54f4.svg";
export { ForwardRef as ReactComponent };